import { Component, OnInit, Input, Inject, Optional, Injector } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserLoginRequest, UserRole } from 'src/app/models/api/user';
import { NotificationService } from 'src/app/services/notification/notification.service';

@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.scss']
})
export class LogInComponent implements OnInit {

  @Input() inDialog = false;

  form: FormGroup;
  authService: AuthService;
  passwordFieldType = 'password';
  error = false;
  loading = false;

  constructor(
    private router: Router,
    private injector: Injector,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<LogInComponent>
  ) {
    setTimeout(() => this.authService = this.injector.get(AuthService));

    if (data) {
      if (data.inDialog) {
        this.inDialog = true;
      }
    }

    this.form = this.formBuilder.group(
      {
        username: [null, [Validators.required]],
        password: [null, [Validators.required]]
      }
    );
  }

  ngOnInit() { }

  login() {
    if (this.form.invalid) {
      console.log('invalid form');

      return;
    }

    this.error = false;
    this.loading = true;

    const loginRequest: UserLoginRequest = { ... this.form.value };
    this.authService.login(loginRequest).subscribe(
      response => {
        console.log(response);

        const returnUrl = this.route.snapshot.queryParams.returnUrl;
        console.log('in login dialog', returnUrl, this.authService.getUserRole());
        
        if (this.inDialog) {
          this.dialogRef.close();
        } else if (this.authService.getUserRole() === UserRole.Agent) { // && returnUrl === '/') {
          switch (response.businessStatus ?? 'UNREGISTERED') {
            case 'UNREGISTERED':
              this.router.navigate(['/','agent','agent-onboarding','account-info']);
              break;
            case 'PENDING':
              this.router.navigate(['/','agent','agent-onboarding','complete']);
              break;
            case 'ACTIVE':
            default:
              this.router.navigate(['/','agent', 'dashboard']);
          }
        } else if (this.authService.getUserRole() === UserRole.Admin) { // && returnUrl === '/') {
          this.router.navigate(['/','admin', 'dashboard']);
        } else if (returnUrl) {
          this.router.navigateByUrl(returnUrl);
        } else if (false) {
          this.router.navigate(['/', 'user', 'profile']);
        } else {
          this.router.navigateByUrl('/');
        }
      },
      error => {
        this.error = true;
        this.loading = false;
      });
  }

  closeDialog() {
    if (this.inDialog) {
      this.dialogRef.close();
    }
  }

  getPageUrl() {
    return new URL(document.URL).pathname;
  }

}
